// Default video constraints we use when requesting media permissions with getUserMedia.
// 30 fps is enforced as a hard max so the camera doesn't quietly hand us 60 fps
// when the device supports it (this previously caused the iPhone encoder to be
// permanently behind capture rate). Width/height are role-specific and applied
// in MediaService.updateVideoStream via setVideoResolution; they intentionally
// stay at full-HD ideal here so the initial permission grant doesn't accidentally
// lock a desktop webcam into a 4:3 native mode like 640x480.
export const DefaultVideoConstraints = {
    facingMode: { ideal: 'environment' }, // Request back camera by default
    width: { ideal: 1920 },
    height: { ideal: 1080 },
    frameRate: { ideal: 30, max: 30 },
};
// Call mode is not part of the 3.2.0 release: this flag hides its entry
// points (the "Start Call" buttons and the 'speakers' accepted-participant
// option) while keeping the underlying code paths intact.
export const CALL_MODE_ENABLED = false;
export const COMPLAINT_REPORT_URL = 'https://forms.gle/a1rXpngeEKx53muU6';
export const MERCHANT_DASHBOARD_LOGIN_URL = 'https://connect.stripe.com/express_login';
export const ELIGIBLE_COUNTRIES_FOR_MERCHANTS = [
    {
        code: 'AU',
        name: 'Australia',
    },
    {
        code: 'AT',
        name: 'Austria',
    },
    {
        code: 'BE',
        name: 'Belgium',
    },
    {
        code: 'BR',
        name: 'Brazil',
    },
    {
        code: 'BG',
        name: 'Bulgaria',
    },
    {
        code: 'CA',
        name: 'Canada',
    },
    {
        code: 'HR',
        name: 'Croatia',
    },
    {
        code: 'CY',
        name: 'Cyprus',
    },
    {
        code: 'CZ',
        name: 'Czech Republic',
    },
    {
        code: 'DK',
        name: 'Denmark',
    },
    {
        code: 'EE',
        name: 'Estonia',
    },
    {
        code: 'FI',
        name: 'Finland',
    },
    {
        code: 'FR',
        name: 'France',
    },
    {
        code: 'DE',
        name: 'Germany',
    },
    {
        code: 'GI',
        name: 'Gibraltar',
    },
    {
        code: 'GR',
        name: 'Greece',
    },
    {
        code: 'HK',
        name: 'Hong Kong',
    },
    {
        code: 'HU',
        name: 'Hungary',
    },
    {
        code: 'IE',
        name: 'Ireland',
    },
    {
        code: 'IT',
        name: 'Italy',
    },
    {
        code: 'JP',
        name: 'Japan',
    },
    {
        code: 'LV',
        name: 'Latvia',
    },
    {
        code: 'LI',
        name: 'Liechtenstein',
    },
    {
        code: 'LT',
        name: 'Lithuania',
    },
    {
        code: 'LU',
        name: 'Luxembourg',
    },
    {
        code: 'MY',
        name: 'Malaysia',
    },
    {
        code: 'MT',
        name: 'Malta',
    },
    {
        code: 'MX',
        name: 'Mexico',
    },
    {
        code: 'NL',
        name: 'Netherlands',
    },
    {
        code: 'NZ',
        name: 'New Zealand',
    },
    {
        code: 'NO',
        name: 'Norway',
    },
    {
        code: 'PL',
        name: 'Poland',
    },
    {
        code: 'PT',
        name: 'Portugal',
    },
    {
        code: 'RO',
        name: 'Romania',
    },
    {
        code: 'SG',
        name: 'Singapore',
    },
    {
        code: 'SK',
        name: 'Slovakia',
    },
    {
        code: 'SI',
        name: 'Slovenia',
    },
    {
        code: 'ES',
        name: 'Spain',
    },
    {
        code: 'SE',
        name: 'Sweden',
    },
    {
        code: 'CH',
        name: 'Switzerland',
    },
    {
        code: 'TH',
        name: 'Thailand',
    },
    {
        code: 'AE',
        name: 'United Arab Emirates',
    },
    {
        code: 'GB',
        name: 'United Kingdom',
    },
    {
        code: 'US',
        name: 'United States',
    },
];
export const MOCK_PLUGIN_ID_PREFIX = 'mock-plugin-';
